import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { ConvertEpochToDate } from "@egovernments/digit-ui-libraries/src/services/atoms/Utils/Date";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

const useSubStep1Logic = ({
  formData,
  userInfo,
  schemeTypeData,
  nonSchemeTypeData,
  id,
  handleSubTabChange,
  handleTabChange,
  setProposedSite,
  setFormData,
}) => {
  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();

  const designType = formData?.proposalType;
  const defaultValues = {
    ...formData,
    fastPASId: formData?.fastPASId,
    proposalType: formData?.proposalType,
    isSpecialProject: formData?.isSpecialProject,
    groundCoverages: formData?.groundCoverages,
    fars: formData?.fars,
    buildingHeight: formData?.buildingHeight,
    previousSetbackFront: formData?.setbackFronts,
    previousSetbackRear: formData?.setbackRears,
    natureOfConstructionOptions: formData?.natureOfConstructionOptions,
  };
  console.log("applicationFlow", applicationFlow);
  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData.filter((district) => !district.code?.includes("up"));
  const [fastPASData, setFastPasData] = useState(null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [isPlinthApproved, setIsPlinthApproved] = useState(false);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [pdfUrls, setPdfUrls] = useState({
    selfDrawingPdfUrl: "",
    approvalCertificateUrl: "",
    selfDrawingPdfId: "",
    approvalCertificateId: "",
  });
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [isCompletionValid, setIsCompletionValid] = useState(true);

  const [
    watchProposalType,
    watchisSpecialProject,
    watchTypeOfProject,
    watchPlotSubdivided,
    watchNeedComp,
    watchplotLeaseHold,
    watchisRevised,
    watchNoOfPLots,
    watchisApprovedLayout,
    watchisSetbackRequired,
    watchPlanOn,
    watchSpecialGroundCoverage,
    watchisSpecialFAR,
    watchProjectType,
    watchnatureOfConstruction,
    watchbuildingClassification,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchSectorNo,
    watchLandMark,
    watchKhasraNo,
    watchTehsil,
    watchCompunding,
  ] = watch([
    "proposalType",
    "isSpecialProject",
    "typeOfProject",
    "plotSubdivided",
    "needCompounding",
    "plotLeaseHold",
    "isRevised",
    "noOfPlots",
    "isApprovedLayout",
    "isSetbackRequired",
    "planOn",
    "isSpecialGroundCoverage",
    "isSpecialFAR",
    "projectType",
    "natureOfConstruction",
    "buildingClassification",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "sectorNo",
    "landMark",
    "khasraNo",
    "tehsil",
    "shortName",
  ]);
  const watchedFields = watch();
  const mappedPlot = formData?.plotNumbers?.length;
  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert = watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isCompounding = watchnatureOfConstruction === "Compounding";
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  const plotInputs = Array.from({ length: totalPlots }, (_, index) => ({
    index: index + 1,
  }));
  const plotNumbers = plotInputs.map((plot) => watchedFields[`plotNumbers[${plot.index}]`]);
  let isLayoutCase;
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData?.fastPASId,
        natureOfConstructionOptions: formData?.natureOfConstructionOptions,
        proposalType: formData?.proposalType,
        isSpecialProject: formData?.isSpecialProject,
        groundCoverages: formData?.groundCoverages,
        fars: formData?.fars,
        buildingHeight: formData?.buildingHeight,
        previousSetbackFront: formData?.setbackFronts,
        previousSetbackRear: formData?.setbackRears,
      });
    }
  }, [formData]);

  useEffect(() => {}, [watchedFields]);

  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);

  useEffect(() => {
    const riskType =
      watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
        ? "Building Plan Low Risk, Self Certification Mode"
        : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") &&
          watchAtivityProposed !== "Row Houses" &&
          watchAtivityProposed !== "Semi Detached" &&
          watchAtivityProposed !== "Detached"
        ? "High Risk and High Nivesh"
        : watchlandUseType === "Commercial"
        ? "High Risk and High Nivesh"
        : watchPlanOn !== "Others"
        ? "Building Plan-Low Risk"
        : "Others";

    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (
      watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
    ) {
      setValue("noOfPlots", 1);
      setValue("natureOfConstruction", "New");
    }
  }, [watchPlanOn]);

  const closeToast = () => setShowToast(null);

  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);
  const isCompletionEligible = (landUseData) => {
    const activityProposed = landUseData?.descriptionOfLand?.activityProposed;
    const plotArea = landUseData?.descriptionOfLand?.landArea;

    const restrictedActivities = ["Row Housing - Single units", "Semi-Detached - Single Units", "Single Housing – EWS", "Single Housing – LIG"];

    // If activity is among restricted ones AND plotArea <= 500 → false
    if (restrictedActivities.includes(activityProposed) && plotArea <= 500) {
      return false;
    }

    // Your ELSE also returned false, so final result is:
    return true;
  };
  const identifyLayoutCase = (data) => {
    if (
      data?.descriptionOfLand?.activityProposed === "Plotted Development" ||
      data?.descriptionOfLand?.activityProposed === "Plotted Development - Affordable"
    ) {
      return true;
    } else return false;
  };

  const Modal = useModal();
  const handleSearchClick = async (applicationNo) => {
    //  Digit.SessionStorage.set("FASTPAS_ID", applicationNo);
    try {
      let response;
      let data;
      let mapSubmissionData;
      let purchasableData;
      let mapSubmissionDataCompletion;
      let plinthData;
      if (applicationNo) {
        response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNo });
        console.log("Response GOt", response);
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`,
          });
          return;
        }
        // else if (response?.BPA?.[0]?.department !== applicationFlow) {
        //   setShowToast({
        //     key: "true",
        //     error: true,
        //     message: `Please use the selected department FASTPASID`,
        //   });
        //   return;
        // }
        data = response?.BPA?.filter((item) => item.applicationType === "FORM_LANDUSE")?.[0];
        mapSubmissionData = response?.BPA?.filter((item) => item.applicationType === "FORM_MAP")?.[0];
        mapSubmissionDataCompletion = response?.BPA?.filter((item) => item.applicationType === "FORM_COMPLETION")?.[0];
        purchasableData = response?.BPA?.filter((item) => item.applicationType === "FORM_PURCHASABLE_FAR")?.[0];
        plinthData = response?.BPA?.filter((item) => item.applicationType === "FORM_PLINTH")?.[0];
        if (plinthData?.land_Id) {
          setIsPlinthApproved(true);
        }
        setPdfUrls({
          selfDrawingPdfUrl: mapSubmissionData?.selfDrawingPdfUrl || "",
          approvalCertificateUrl: mapSubmissionData?.approvalCertificateUrl || "",
          selfDrawingPdfId: mapSubmissionData?.selfDrawingPdfId || "",
          approvalCertificateId: mapSubmissionData?.approvalCertificateId || "",
        });
        Digit.SessionStorage.set("MAP_SANCTION_DETAIL", mapSubmissionData);
        const completionEligible = isCompletionEligible(data);
        setIsCompletionValid(completionEligible);
        if (!completionEligible) {
          Modal("Submission Blocked", `As per condition, no need to apply`, "error");
          return;
        }
        isLayoutCase = identifyLayoutCase(data);
        if (data) {
          const uuid = userInfo?.uuid;
          if (uuid) {
            const usersResponse = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
            const userDetail = usersResponse?.user?.[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (data?.additionalDetails?.professionalInformation?.mobileNumber === userDetail?.mobileNumber) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`,
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`,
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID_DATA", { landUse: data, mapSubmission: mapSubmissionData });
        const updatedDocuments = data?.documents?.map((doc) => ({
          ...doc,
          documentRemarks: null,
          documentStatus: null,
        }));
        const newFormData = {
          ...formData,
          landInfo: {
            ...data.landInfo,
            address: data?.landInfo?.address,
          },
          land_Id: data?.land_Id,
          selectedCity: data?.selectedCity,
          selectedUnit: data?.selectedUnit,
          documents: updatedDocuments,
          descriptionOfLand: data?.descriptionOfLand,
          nocDetails: data?.nocDetails,
          khasraDetails: data?.khasraDetails,
          totalBuildUpArea: mapSubmissionData?.totalBuildUpArea,

          plotInfo: {
            ...mapSubmissionData?.plotInfo,
            estimatedCost: mapSubmissionData?.plotInfo?.estimatedCost,
          },
        };

        setFormData((prevState) => ({
          ...prevState,
          ...newFormData,
        }));
        const sanctionDate = ConvertEpochToDate(mapSubmissionData?.auditDetails?.lastModifiedTime) || "";
        setFastPasData(data);
        setPurchasableData(purchasableData);
        setValue("zoneType", data?.descriptionOfLand?.landUsesType);
        setValue("fastPASId", applicationNo);
        setValue("primaryUse", data?.descriptionOfLand?.activityAsPerMap);
        setValue("landMark", data?.descriptionOfLand?.landMark);
        setValue("sectorNo", data?.descriptionOfLand?.sectorNo);
        setValue("khasraNo", data?.descriptionOfLand?.khasraWithArea[0]?.khasraNo);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("planOn", "FORM_MAP_COMPLETION");
        setValue("riskType", data?.riskType);
        setValue("activityProposed", data?.descriptionOfLand?.activityProposed);
        setValue("plotArea", data?.descriptionOfLand?.landArea);
        setValue("plotAreaDoc", data?.descriptionOfLand?.plotAreaDoc);
        setValue("plotAreaPos", data?.descriptionOfLand?.plotAreaPossession);
        setValue("siteAddress", data?.descriptionOfLand?.landAddress);
        setValue("tehsil", data?.landInfo?.owners?.[0]?.permanentAddress?.tehsil);
        setValue("typeOfArea", data?.descriptionOfLand?.developmentArea);
        setValue("subZoneType", data?.descriptionOfLand?.subLandUseAsPerLayout);
        setValue("department", data?.department);
        setValue("prevFileNo", mapSubmissionData?.applicationNo || data?.applicationNo);
        setValue("layoutsanctionDate", data?.layoutsanctionDate);
        setValue("validityDate", data?.validityDate);
        setValue("compoundingSanctionDate", sanctionDate);
        setValue("applicationType", "FORM_COMPLETION");
        setValue("selectedOffice", data?.selectedOffice);
        const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
        const plotArea = data?.descriptionOfLand?.landArea;
        setRiskType(data?.riskType);
        setSchemeType(isApproved);
        if (!isApproved) {
          setValue("planOn", "Others");
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  const filterSchemeData = (authority, masterData, category, subCategory) => {
    const authorityData = masterData?.find((item) => item.name === authority);
    if (!authorityData) return { landUseList: [], landSubUseList: null };
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
      })) || [];
    let landSubUseList = null;
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
          })) || [];
      }
    }
    return { landUseList, landSubUseList };
  };

  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    const landUseList = masterData?.[0]?.CategeryType?.map((item) => {
      return { name: item.Categery, label: item.Categery };
    });
    const landSubUseList = masterData?.[0]?.CategeryType?.filter((item) => item.Categery === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item };
    });
    return { landUseList, landSubUseList };
  };

  const { landUseList, landSubUseList } = !schemeType
    ? filterSchemeData(fastPASData?.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType)
    : filterNonSchemeData(fastPASData?.selectedOffice, nonSchemeTypeData, watchlandUseType, watchSubZoneType);

  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };

  return {
    t,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    getValues,
    updistricts,
    fastPASData,
    setFastPasData,
    purchasableData,
    setPurchasableData,
    user,
    setUser,
    riskType,
    setRiskType,
    showToast,
    setShowToast,
    dropDownData,
    schemeType,
    setSchemeType,
    declarationChecked,
    setDeclarationChecked,
    watchedFields,
    mappedPlot,
    totalPlots,
    isSelfCert,
    isCompounding,
    fullRows,
    remainingPlots,
    plotInputs,
    plotNumbers,
    handleSearchClick,
    landUseList,
    landSubUseList,
    handleDeclarationChange,
    closeToast,
    applicationFlow,
    DepartmentSelector,
    file,
    setFile,
    handleSubTabChange,
    handleTabChange,
    id,
    formData,
    userInfo,
    setProposedSite,
    isCompletionValid,
    isLayoutCase,
    isPlinthApproved,
    pdfUrls,
  };
};

export default useSubStep1Logic;
